<template>
  <div v-if="!$page" />

  <div v-else class="themes page">
    <header class="header -column">
      <h1 v-reveal="{ delay: 550 }" class="header__subtitle">{{ $page.header.hat }}</h1>
      <p v-reveal="{ delay: 600 }" class="header__title">{{ $page.header.title }}</p>
      <RawHtml :html="$page.header.description" v-reveal="{ delay: 650 }" />
    </header>

    <section class="section -first">
      <h2 class="section__title">{{ $page.labels.view }}</h2>

      <ul v-reveal="{ delay: 750 }" class="theme__list row -wrap -spread">
        <ThemeCard
          v-for="(theme, idx) in themes"
          :key="theme.id"
          v-reveal="{ delay: idx * 75 }"
          :theme="theme"
          class="themes__item"
          :labels="$page.labels"
        />
      </ul>
    </section>
    <CtaContactSection
      v-reveal="{ delay: 75 }"
      :title="$page.contact.title"
      :subtitle="$page.contact.description"
      :link-label="$page.contact.label"
    />
  </div>
</template>

<script>
import ThemeCard from '@/components/cards/ThemeCard.vue'
import RawHtml from '@/components/global/RawHtml.vue'
import CtaContactSection from '@/components/sections/CtaContactSection.vue'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Themes',
  beetPage: 'themes',
  mixins: [PageMetaMixin],
  components: { RawHtml, CtaContactSection, ThemeCard },
  computed: {
    themes() {
      return Object.values(this.$store.getters.themes)
        .toSorted((a, b) => {
          if (a.upcoming && !b.upcoming) return 1
          if (!a.upcoming && b.upcoming) return -1
          return 0
        })
        .toSorted((a, b) => {
          if (a.children.length && !b.children.length) return -1
          if (!a.children.length && b.children.length) return 1
          return 0
        })
    },
  },
}
</script>
